export default "__VITE_ASSET__BsMPVMlO__"